/**
 * Simple logger that only outputs in development.
 * Use this instead of console.* to avoid leaking sensitive info in production.
 */

import { captureLoggerError } from '@/lib/sentry/capture'

const isDev = process.env.NODE_ENV === 'development'

export const logger = {
  log: (...args: unknown[]) => {
    if (isDev) {
      console.log(...args)
    }
  },
  warn: (...args: unknown[]) => {
    if (isDev) {
      console.warn(...args)
    }
  },
  error: (...args: unknown[]) => {
    captureLoggerError(args)
    console.error(...args)
  },
  info: (...args: unknown[]) => {
    if (isDev) {
      console.info(...args)
    }
  },
}
